import { LinkType } from '@nerdwallet/react-apply-now';
export default {
  defaultSortKey: 'currentOffers',
  className: 'brokers',
  reviewTarget: '_blank',
  columns: [{
    title: 'Broker',
    className: 'broker',
    sort: {
      sortable: false,
      key: 'rating',
      order: 'desc'
    },
    content: [{
      type: 'image',
      config: {
        data_keys: ['logo'],
        className: 'clearfix product-image-small',
        provider_key: 'name',
        provider_id: 'id',
        product_topic: 'Brokers',
        link_type: LinkType.institutionImage,
        link_data_key: 'website'
      }
    }, {
      type: 'stars',
      value: 'rating'
    }, {
      type: 'label',
      config: {
        data_keys: ['name'],
        className: 'annotation center'
      }
    }]
  }, {
    title: 'Highlights',
    className: 'highlights desktop-only',
    sort: {
      sortable: false,
      key: 'Highlights'
    },
    content: [{
      type: 'label',
      config: {
        data_keys: ['summaryShort'],
        className: 'annotation'
      }
    }]
  }, {
    title: 'Commissions',
    className: 'commissions',
    sort: {
      sortable: false,
      key: 'commissions'
    },
    content: [{
      type: 'label',
      config: {
        text: 'Commissions',
        className: 'column-header mobile'
      }
    }, {
      type: 'label',
      config: {
        data_keys: ['tradeFee'],
        format: 'currency',
        className: 'product-value'
      }
    }, {
      type: 'label',
      config: {
        data_keys: ['tradeFeeCaption'],
        className: 'annotation'
      }
    }, {
      type: 'managementFee'
    }, {
      type: 'label',
      config: {
        data_keys: ['commissionsBlurb'],
        className: 'annotation'
      }
    }]
  }, {
    title: 'Account Minimum',
    className: 'account-minimum align-right-mobile',
    sort: {
      sortable: false,
      key: 'accountMinimum'
    },
    content: [{
      type: 'label',
      config: {
        text: 'Account Minimum',
        className: 'column-header mobile'
      }
    }, {
      type: 'label',
      config: {
        data_keys: ['accountMinimum'],
        format: 'currency-estimate',
        className: 'product-value'
      }
    }]
  }, {
    title: 'Current Offers',
    className: 'current-offers highlight-column',
    sort: {
      sortable: false,
      key: 'currentOffers'
    },
    content: [{
      type: 'label',
      config: {
        text: 'Current Offers',
        className: 'column-header mobile'
      }
    }, {
      type: 'label',
      config: {
        data_keys: ['promotionValue'],
        className: 'product-value'
      }
    }, {
      type: 'label',
      config: {
        data_keys: ['promotionLabel'],
        className: 'annotation'
      }
    }]
  }, {
    title: 'Start Investing',
    className: 'start-investing cta-column',
    sort: {
      sortable: false,
      key: 'total'
    },
    content: [{
      type: 'label'
    }, {
      type: 'apply',
      config: {
        data_keys: ['name', 'apply'],
        provider_key: 'slug',
        link_type: LinkType.applyNowButton,
        provider_id: 'id',
        product_topic: 'Brokers',
        link_data_key: 'website',
        ctype: 'Offer',
        buttonText: 'Learn more',
        name: 'name'
      }
    }]
  }],
  details: {
    component: 'broker_details'
  }
};